import { CheckCheck } from "lucide-react";
import { perms } from "../api/codes";
import { api } from "../api/api";
import { ProtectedElement } from "../components/ProtectedElement/ProtectedElement";
import { ReactComponent as LoadingIcon } from "../images/loading.svg";

export const ApprovalText = ({
  id,
  level,
  setRefresh,
  setAprvlLoader,
  toast,
  view,
  aprvlLoader,
  module,
  apiUrl,
}) => {

  if (!level) return;
  
  return (
    <>
      {id && level !== "" && level !== 0 && (
        <div style={{ padding: "15px 0 0" }}>
          <h4 style={{ color: "gray", margin: "0" }}>
            Approval level:{" "}
            <span style={{ color: "black", fontWeight: "400" }}>
              {" "}
              {level}
              <sup>TH</sup> Level
            </span>
          </h4>
        </div>
      )}

      {view && (
        <ProtectedElement module={module} perm={perms.approver}>
          <div style={{ display: "flex", justifyContent: "end" }}>
            <button
              className="btn-approve"
              disabled={!view || aprvlLoader}
              style={{
                cursor: !view || aprvlLoader ? "not-allowed" : "",
                color: !view || aprvlLoader ? "gray" : "",
              }}
              onClick={async () => {
                setAprvlLoader(true);
                try {
                  const res = await api.patch(apiUrl + id + "/approver/");
                  if (res.status === 200) {
                    toast.open(res?.data, "success");
                    setRefresh((prev) => !prev);
                  }
                } catch (error) {
                  toast.open(
                    error?.response?.data[0] || "Something Went Wrong",
                    "error"
                  );
                } finally {
                  setAprvlLoader(false);
                }
              }}
            >
              {aprvlLoader ? (
                <LoadingIcon height={20} width={20} />
              ) : (
                <>
                  <CheckCheck size={15} /> Approve
                </>
              )}
            </button>
          </div>
        </ProtectedElement>
      )}
    </>
  );
};
